export default __webpack_public_path__ + "static/media/newbie_project1.c9ab6280.jpg";